type PrepareCourseSeoParams = {
	title: string;
	description: string;
	author: {
		name: string;
		secondName: string;
	};
	price: number;
};

export const prepareCourseSeo = ({ title, author, price, description }: PrepareCourseSeoParams) => {
	const name = `${author.name} ${author.secondName}`;
	const preparedTitle = title.replace("Курс", "");
	const seoTitle = `Курс «${preparedTitle}» от ${name} по цене ${price} рублей — обучающая платформа selfschool.ru`;
	const seoDescription = `Курс «${preparedTitle}» от ${name} по цене ${price} рублей ${description} — большое количество бесплатных обучающих программ и курсов на нашей платформе selfschool.ru`;

	return {
		seoTitle,
		seoDescription,
	};
};
